'use strict';

export class StructureSectionsNavigCtrl
{
	$scope;
	jsDataService;
	nodeList = [];
	datasheetNodeList = [];
	navigationList = [];
	datasheetNavigationList = [];
	currentIndex = -1;
	datasheetCurrentIndex = -1;

	navUrl = 'preview_url';

	constructor($scope, jsDataService){
		'ngInject';
		this.init($scope, jsDataService);
//		this.$scope = $scope;
//		let strNodeList = jsDataService.get('structureTreeNodeList', false);
//		if(false !== strNodeList){
//			this.nodeList = strNodeList;
//			this.navigationList = jsDataService.get('structureNavigationList', false);
//			let idx = jsDataService.get('structureCurrentIndex', false);
//			if(false !== idx){
//				this.currentIndex = idx;
//			}
//		}
//		else{
//			this.makeStructureList(jsDataService.get('structureTree', {}));
//			jsDataService.set('structureTreeNodeList', this.nodeList);
//			jsDataService.set('structureNavigationList', this.navigationList);
//			if(this.currentIndex > -1){
//				jsDataService.set('structureCurrentIndex', this.currentIndex);
//			}
//		}
	}

	init($scope, jsDataService){
		this.$scope = $scope;
		let strNodeList = jsDataService.get('structureTreeNodeList', false);
		let strDatasheetNodeList = jsDataService.get('datasheetTreeNodeList', false);

		if(false !== strNodeList){
			this.nodeList = strNodeList;
			this.navigationList = jsDataService.get('structureNavigationList', false);
			let idx = jsDataService.get('structureCurrentIndex', false);
			if(false !== idx){
				this.currentIndex = idx;
			}
		}
		else{
			this.makeStructureList(jsDataService.get('structureTree', {}));
			jsDataService.set('structureTreeNodeList', this.nodeList);
			jsDataService.set('structureNavigationList', this.navigationList);
			if(this.currentIndex > -1){
				jsDataService.set('structureCurrentIndex', this.currentIndex);
			}
		}

		if (false !== strDatasheetNodeList) {
			this.datasheetNodeList = strDatasheetNodeList.filter(node => node.structure_key === "42_payments");

			this.datasheetNavigationList = jsDataService.get('datasheetNavigationList', false);
			let idx = jsDataService.get('datasheetStructureCurrentIndex', false);
			if (false !== idx) {
				this.datasheetCurrentIndex = idx;
			}
		} else {
			this.makeStructureList(jsDataService.get('datasheetTree', {}));
			jsDataService.set('datasheetTreeNodeList', this.datasheetNodeList);
			jsDataService.set('datasheetNavigationList', this.datasheetNavigationList);
			if (this.datasheetCurrentIndex > -1) {
				jsDataService.set('datasheetStructureCurrentIndex', this.datasheetCurrentIndex);
			}
		}
	}

	makeStructureList(tree){
		for(let nodeKey in tree){
			let strTree;
			if(tree[nodeKey].haschilds){
				strTree = tree[nodeKey].childs;
				delete tree[nodeKey].childs;
			}
			this.nodeList.push(tree[nodeKey]);
			if(this.isAction(tree[nodeKey])){
				this.navigationList.push(tree[nodeKey]);
			}
			if(tree[nodeKey].haschilds){
				this.makeStructureList(strTree);
			}
//			else{
//				this.navigationList.push(tree[nodeKey]);
//			}
//			if(typeof(tree[nodeKey].current) !== 'undefined' && tree[nodeKey].current){
//				this.currentIndex = this.navigationList.length - 1;
//			}
		}
		const index = this.navigationList.findIndex(obj => obj.current === true);
		this.currentIndex = index;
	}

	nodeTitleFormated(node){
		let idt = '';
		let nr = '';
		const tim = 8;
//		const sp = '&nbsp;';
//		if(node.level > 1){
//			idt = sp.repeat(tim * (parseInt(node.level) - 1));
//		}
		if(node.numbered == 1 && node.number !== ''){
			nr = node.number + ' ';
		}
		return idt + nr + node.title;
	}

	actionPreview(ev, node){
		if(this.isPreview(node)){
			this.$scope.goUrl(node.preview_url);
		}
	}

	actionEdit(ev, node){
		if(this.isEdit(node)){
			this.$scope.goUrl(node.edit_url);
		}
	}

	isPreviousLink(){
		return (this.currentIndex > 0);
	}

	isNextLink(){
		return (this.currentIndex > -1 && this.currentIndex < (this.navigationList.length-1));
	}

	navPrevious(){
		if(this.isPreviousLink() && typeof(this.navigationList[this.currentIndex - 1]) !== 'undefined' && typeof(this.navigationList[this.currentIndex - 1][this.navUrl]) !== 'undefined'){
			this.$scope.goUrl(this.navigationList[this.currentIndex - 1][this.navUrl]);
		}
	}

	navNext(){
		if(this.isNextLink() && typeof(this.navigationList[this.currentIndex + 1]) !== 'undefined' && typeof(this.navigationList[this.currentIndex + 1][this.navUrl]) !== 'undefined'){
			this.$scope.goUrl(this.navigationList[this.currentIndex + 1][this.navUrl]);
		}
	}

	getPreviousLink(){
		if(this.isPreviousLink() && typeof(this.navigationList[this.currentIndex - 1]) !== 'undefined' && typeof(this.navigationList[this.currentIndex - 1][this.navUrl]) !== 'undefined'){
			return this.navigationList[this.currentIndex - 1][this.navUrl];
		}
		return '';
	}

	getNextLink(){
		if(this.isNextLink() && typeof(this.navigationList[this.currentIndex + 1]) !== 'undefined' && typeof(this.navigationList[this.currentIndex + 1][this.navUrl]) !== 'undefined'){
			return this.navigationList[this.currentIndex + 1][this.navUrl];
		}
		return '';
	}

	isPreview(node){
		return (this.isAction(node) && typeof(node.preview_url) !== 'undefined');
	}

	isEdit(node){
		return (this.isAction(node) && typeof(node.edit_url) !== 'undefined');
	}

	isAction(node){
		return (typeof(node.is_page) !== 'undefined' && (node.is_page === 1 || node.is_page === '1' || node.is_page === 'true' || true === node.is_page));
	}

	isCurrent(node){
		return (typeof(this.navigationList[this.currentIndex]) !== 'undefined' && this.navigationList[this.currentIndex].id === node.id);
	}
}